<template>
  <div class="case-file-dailog col-block block">
    <div class="sample-file-container col-block">
      <div class="sample-file-title">{{ $t('DIALOG.caseFile.___title') }}</div>
      <div :style="{ height: '15px' }"></div>
      <div class="sample-file-content col-block">
        <template v-if="['fastq'].includes(param.caseData.dataset)">
          <div class="sample-file-info-container row-block flex-start">
            <div class="sample-file-info-block col-block flex-start" :style="{ flex: 2 }">
              <div class="sample-file-info-title">{{ $t('DIALOG.caseFile.fastq.infoTitle.___omics') }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-info-content">{{ param.caseData.omics || '--' }}</div>
            </div>
            <div class="sample-file-info-block col-block flex-start" :style="{ flex: 3 }">
              <div class="sample-file-info-title">{{ $t('DIALOG.caseFile.fastq.infoTitle.___pipeline') }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-info-content">{{ param.caseData.pipeline || '--' }}</div>
            </div>
            <div class="sample-file-info-block col-block flex-start" :style="{ flex: 3 }">
              <div class="sample-file-info-title">{{ $t('DIALOG.caseFile.fastq.infoTitle.___libraryType') }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-info-content">{{ param.caseData.library_type || '--' }}</div>
            </div>
            <div class="sample-file-info-block col-block flex-start" :style="{ flex: 2 }">
              <div class="sample-file-info-title">{{ $t('DIALOG.caseFile.fastq.infoTitle.___totalBases') }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-info-content" :title="param.caseData.total_bases">{{ param.caseData.total_bases ? fixNumber(param.caseData.total_bases * Math.pow(10, -9), 0.01) + ' G' : '--' }}</div>
            </div>
          </div>
          <div :style="{ height: '15px' }"></div>
          <div class="sample-file-main-field row-block flex-start">
            <div class="sample-file-main-container col-block flex-start" :style="{ flex: 1 }">
              <div class="sample-file-main-title">{{ $t('DIALOG.caseFile.fastq.___title') }}</div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-list-container col-block">
                <template v-for="(fileGroup, index) in fileGroups">
                  <div class="sample-file-list-block row-block flex-start" :key="index">
                    <div
                      class="sample-file"
                      :style="{ flex: 1 }"
                      v-html="$t('DIALOG.caseFile.fastq.___file', { set: fileGroup[0].group.replace(/L/, ''), read: 'R' + fileGroup[0].read_strand, file: fileGroup[0].name })"
                    ></div>
                    <div
                      v-if="fileGroup[1]"
                      class="sample-file"
                      :style="{ flex: 1 }"
                      v-html="$t('DIALOG.caseFile.fastq.___file', { set: fileGroup[1].group.replace(/L/, ''), read: 'R' + fileGroup[1].read_strand, file: fileGroup[1].name })"
                    ></div>
                  </div>
                  <hr v-if="fileGroups[index + 1]" :key="'hr-' + index">
                </template>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="['vcf'].includes(param.caseData.dataset)">
          <div class="sample-file-main-field row-block flex-start">
            <div class="sample-file-main-container col-block flex-start" v-for="(fileGroup, dataset, index) in fileGroups" :key="index" :style="{ flex: 1 }">
              <div
                class="sample-file-main-title"
                v-html="{
                  'snv': $t('DIALOG.caseFile.vcf.___snvTitle'),
                  'sv': $t('DIALOG.caseFile.vcf.___svTitle'),
                  'str': $t('DIALOG.caseFile.vcf.___strTitle')
                }[dataset]"
              ></div>
              <div :style="{ height: '6px' }"></div>
              <div class="sample-file-list-container col-block">
                <div class="sample-file-list-block row-block flex-start" v-for="(file, findex) in fileGroup" :key="findex">
                  <div class="sample-file" :style="{ flex: 1 }">{{ file.name }}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div :style="{ height: '15px' }"></div>
    <hr class="no-margin">
    <div :style="{ height: '15px' }"></div>
    <div class="analysis-file-container col-block flex-start">
      <div class="analysis-file-block" v-for="(fileType, type, tindex) in param.analysisFiles" :key="tindex">
        <div class="block-content col-block">
          <div class="af-title-block row-block">
            <div class="af-title row-block">
              <div class="title">{{ type }}</div>
              <borCor
                v-if="type === 'Analysis Files'"
                :background="'white'"
                :border="'#CCCCCC'"
                :radius="'0px'"
                :width="'300px'"
                :blockStyle="{ padding: '8px' }"
              >
                <div slot="trigger">
                  <img :src="require('../../assets/images/case-af-info-icon.svg')" alt="">
                </div>
                <div slot="content">
                  <div v-html="$t('DIALOG.caseFile.limit.___limitInfo')"></div>
                </div>
              </borCor>
            </div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div :style="{ height: '10px' }"></div>
          <div class="af-container row-block flex-start" v-for="(fileGroup, group, tindex) in fileType" :key="tindex">
            <div class="af-group-title" :style="{ flex: 1 }" v-html="(tindex + 1) + '. ' + group + (fileGroup.some(file => file.download_limit) ? ' <span>(' + $t('DIALOG.caseFile.limit.___limitAlert', { times: numberMap[fileGroup.find(file => file.download_limit).download_limit] }) + ')</span>' : '')"></div>
            <div class="af-block col-block" :style="{ flex: 1 }">
              <div class="file row-block flex-start" v-for="(file, findex) in fileGroup" :key="findex">
                <component
                  class="link"
                  :is="(file.download_limit && (file.download_used >= file.download_limit)) ? 'div' : 'a'"
                  :style="{ flex: 1 }"
                  @click="!(file.download_limit && (file.download_used >= file.download_limit)) && downloadFile(file)"
                >{{ file.name + ((file.download_limit && (file.download_used >= file.download_limit)) ? ' (' + $t('DIALOG.caseFile.limit.___times', { times: file.download_used }) + ')' : '') }}</component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___cancel') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { API_ROOT } from '../../api/config'
import borCor from '../../components/tool/newBorCor'
import { sortData, groupBy, fixNumber } from '../../constants/global/util'

export default {
  components: {
    borCor
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    fileGroups () {
      if (this.param.caseData.dataset === 'fastq') {
        return groupBy(sortData(this.param.sampleFiles, file => file.read_strand), file => file.group)
      } else if (this.param.caseData.dataset === 'vcf') {
        return groupBy(this.param.sampleFiles, file => file.dataset, true)
      }
    },
    // static
    numberMap () {
      return {
        'en': [null, 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN'],
        'ja': [null, 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT', 'NINE', 'TEN']
      }[this.$i18n.locale]
    },
    // global
    fixNumber () { return fixNumber }
  },
  methods: {
    downloadFile (file) {
      let url = API_ROOT + 'global/files/download?file_id=' + file.id + '&class_name=' + file.class_name + '&access_token=' + this.$ls.get('userInfo').access_token
      window.open(url)
      file.download_used++
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseFile.vue